import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom/client'; // Updated import for React 18
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom'; // Updated for React Router v6
import AdminLayout from 'layouts/Admin/Admin.js';
import RTLLayout from 'layouts/RTL/RTL.js';
import 'assets/scss/black-dashboard-react.scss';
import 'assets/demo/demo.css';
import 'assets/css/nucleo-icons.css';
import MyUserProfile from 'myNewFolder/MYFromWork/UserProfile';
import SignIn from 'MY_LOGIN_AND_SIGNUP/check';
import Students_Table from './STUDENT_MODULE/student_info_table';
import Edit_Student from './STUDENT_MODULE/Student_Edit._Form';
import Book_Add_Step1 from 'Book_Management_Module/Book_Add_Step/Book_Add_Step1';
import Book_Add_Page from 'Book_Management_Module/Book_Add_page';
import GetUser from './Utilities/GetUser';
import NotificationAlert from 'react-notification-alert';
import PrivateRoute from 'PrivateRoute';
import routes from 'routes';
import MeetingScreen from 'layouts/SessionManagement/MeetingScreen/MeetingScreen';
import SessionManagement from 'layouts/SessionManagement/SessionManagement';

const App = ({ hasWebex }) => {
  const [webex, setWebex] = useState('');
  const [meeting, setMeeting] = useState('');

  const notifi = useRef();

  console.log(webex, meeting, 'webex index');

  const notify = (msg, err) => {
    let color = err === false ? 'success' : 'danger';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === false ? 'Success' : 'Error'}</b> - {msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notifi.current) {
      notifi.current.notificationAlert(options);
    }
  };

  const isAuthenticated = () => {
    if (typeof window === 'undefined') {
      return false;
    }
    return localStorage.getItem('uid') ? true : false;
  };

  return (
    <>
      <audio id='messageIn'>
        <source src={require('./assets/audio/msgIn.ogg')} type='audio/ogg' />
        <source src={require('./assets/audio/msgIn.mp3')} type='audio/mpeg' />
        Your browser does not support the audio element.
      </audio>

      <audio id='messageOut'>
        <source src={require('./assets/audio/msgOut.ogg')} type='audio/ogg' />
        <source src={require('./assets/audio/msgOut.mp3')} type='audio/mpeg' />
        Your browser does not support the audio element.
      </audio>

      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path='/check' element={<GetUser />} />
          <Route path='/login' element={<SignIn />} />
          <Route path='/book-step-1' element={<Book_Add_Step1 />} />
          <Route path='/' element={<GetUser />} />

          <Route
            path='/session'
            element={<MeetingScreen webex={webex} meeting={meeting} />}
          />

          {/* Admin Layout Routes */}
          <Route path='/admin' element={<AdminLayout />}>
            {routes.map((prop, key) => {
              if (prop.layout === '/admin') {
                return (
                  <Route
                    key={key}
                    path={prop.path} // Use relative paths here
                    element={
                      prop.path === 'session-managemnt' ? (
                        <SessionManagement
                          setWebex={setWebex}
                          webex={webex}
                          hasWebex={!webex ? false : true}
                          setMeeting={setMeeting}
                        />
                      ) : (
                        <prop.component />
                      )
                    }
                  />
                );
              } else {
                return null;
              }
            })}
            {/* Fallback route */}
            {/* <Route path='*' element={<Navigate to='/admin/tables' />} /> */}
          </Route>

          {/* RTL Layout Routes */}
          <Route path='/rtl' element={<RTLLayout />} />

          {/* Fallback Route */}
          <Route path='*' element={<Navigate to='/admin/tables' />} />
        </Routes>
      </Router>

      <div
        id='loading-indicator'
        style={{
          width: '100vw',
          height: '100vh',
          position: 'absolute',
          background: '#eef1f8',
          zIndex: 99999,
          opacity: 0.6,
          top: 0,
          left: 0,
          display: 'none',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={require('./assets/img/loading.gif')} width='100px' />
      </div>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
